<template>
  <BaseSelect v-bind="$attrs"
              :value="value"
              :options="items"
              :filterable="false"
              :loading="pendingCity"
              text-key="Description"
              @input="$emit('input', $event)"
              @focus="onCitySearch"
              @search="onCitySearch"
              @blur="items = []">
<!--    <template v-slot:current="{option}">-->
<!--     ХХщз-->
<!--    </template>-->
<!--    <template v-slot:option="{option}">-->
<!--      {{ option.Number }} - {{ option.ShortAddress }}-->
<!--    </template>-->
  </BaseSelect>
</template>

<script>
  import axios, {CancelToken} from 'axios'

  let cancel;

  export default {
    name: 'NovaPoshtaAddress',
    props: {
      value: [String, Object],
      cityRef: String,
      cityName: String,
    },
    data() {
      return {
        pendingCity: false,
        items: []
      }
    },
    methods: {
      onCitySearch(value) {
        this.pendingCity = true

        if (cancel) {
          cancel()
        }

        const props = {
          "apiKey": "bf87c735810360239c039d816b9b779e",
          "modelName": "AddressGeneral",
          "calledMethod": "getWarehouses",
          "methodProperties": {
            "Limit": 10,
            "FindByString": value
          }
        }

        if(this.cityRef) {
          props.methodProperties.CityRef = this.cityRef
        } else {
          props.methodProperties.CityName = this.cityName
        }

        axios.post('https://api.novaposhta.ua/v2.0/json/', props, {
          cancelToken: new CancelToken(function executor(c) {
            // An executor function receives a cancel function as a parameter
            cancel = c;
          })
        }).then(({data}) => {
          this.items = this.$get(data, 'data')
        }).finally(() => {
          this.pendingCity = false
        })
      }
    }
  }
</script>

<style lang="less">

</style>
